import Swiper from 'swiper'; // eslint-disable-line
import { Navigation, Pagination, Scrollbar } from 'swiper/modules'; // eslint-disable-line

// ===================================================
// Image Sliders
// ===================================================
const image_sliders = document.querySelectorAll('[data-image-slider]');

image_sliders.forEach((item) => {

    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        lazy: true,
        spaceBetween: 15,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev')
        },
        modules: [Navigation]
    });

});

// ===================================================
// slider in fancybox
// ===================================================
const popup_sliders = document.querySelectorAll('[data-modal-image-slider]');

popup_sliders.forEach((item) => {

    const popup_swiper = new Swiper(item.querySelector('.swiper'), {
        init: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        lazy: true,
        spaceBetween: 15,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev')
        },
        modules: [Navigation]
    });

    // Initialize slider when fancybox is shown
    item.addEventListener('fancybox.shown', () => {
        popup_swiper.init();
    });

    // reset slider to beginning when fancybox is closed
    item.addEventListener('fancybox.hidden', () => {
        setTimeout(() => {
            popup_swiper.slideTo(0, 0);
        }, 350);
    });
});

// ===================================================
// Case Study image slider
// ===================================================
const case_study_sliders = document.querySelectorAll('[data-case-study-image-slider]');

case_study_sliders.forEach((item) => {

    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: 'auto',
        // slidesPerGroup: 2,
        grabCursor: true,
        centeredSlides: true,
        spaceBetween: 15,
        // watchSlidesProgress: true,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev')
        },
        modules: [Navigation]
    });

});

// ===================================================
// industry slider
// ===================================================
const industry_slider = document.querySelector('[data-industry-slider]');

if (industry_slider) {

    industry_slider.querySelector('.swiper').classList.add('swiper--with-scrollbar');

    new Swiper(industry_slider.querySelector('.swiper'), {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        slidesPerGroupAuto: true,
        grabCursor: true,
        spaceBetween: 15,
        watchSlidesProgress: true,
        breakpoints: {
            1025: {
                spaceBetween: 25
            }
        },
        navigation: {
            nextEl: industry_slider.querySelector('.swiper-button-next'),
            prevEl: industry_slider.querySelector('.swiper-button-prev')
        },
        scrollbar: {
            el: industry_slider.querySelector('.swiper-scrollbar'),
            draggable: true
        },
        modules: [Navigation, Scrollbar]
    });
}


